import {
    CHATBOT_USER,
    SAVE_MESSAGE,
    SAVE_MANAGE_CODE,
    CHATBOT_LOGIN,
    SAVE_TIME,
} from '../_actions/types';

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = {messages:[]}, action) {
    
    switch (action.type) {

        case SAVE_MANAGE_CODE:
            return {...state, messages: state.messages.concat(action.payload)}

        case SAVE_TIME:
            return {...state, messages: state.messages.concat(action.payload)}

        case SAVE_MESSAGE:
            if(action.delete) return {...state, messages: []}
            return {...state, messages: state.messages.concat(action.payload)}
                
        case CHATBOT_USER:
            return {...state, messages: state.messages.concat(action.payload)}

        case CHATBOT_LOGIN:
            return {...state, messages: state.messages.concat(action.payload)}

        default:
            return state;
    }
}